<template>
  <div class="order-modal">
    <div class="modal fade" id="order-modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-fullscreen-md-down modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div class="order-id ms-3">訂單編號#{{ id }}</div>
            <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="ms-3 me-3" v-if="order">
              <section class="mb-5">
                <div>
                  <div class="title mb-3">訂單資料</div>
                  <div class="container">
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">會員姓名</div>
                      <div class="col-8">{{ user.alias }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">付款人姓名</div>
                      <div class="col-8" v-if="order.billingAddress">{{ order.billingConsignee }}</div>
                      <div class="col-8" v-else>{{ order.consignee }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">付款人電話</div>
                      <div class="col-8" v-if="order.billingAddress">{{ order.billingMobile }}</div>
                      <div class="col-8" v-else>{{ order.mobile }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">付款人Email</div>
                      <div class="col-8" v-if="order.billingAddress">{{ order.billingEmail }}</div>
                      <div class="col-8" v-else>{{ order.email }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">帳單地址</div>
                      <div class="col-8" v-if="order.billingAddress">{{ order.billingAddress }}</div>
                      <div class="col-8" v-else>{{ order.zipcode }} {{ getRegionName(order.city ) }}{{ getRegionName(order.district ) }} {{ order.address }}<template v-if="order.addressName">({{ order.addressName }})</template></div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">總金額</div>
                      <div class="col-8">{{ util.toPriceFormat(order.goodsAmount) }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">付款方式</div>
                      <div class="col-8">{{ order.payName }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3" v-if="order.payId === constant.PAY_TYPE.ATM">
                      <div class="col-4">付款資訊</div>
                      <div class="col-8">
                        <div v-html="atmPaymentInfo"></div>
                      </div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3 align-items-center">
                      <div class="col-4">付款狀態</div>
                      <div class="col-8 d-flex align-items-center">
                        <span>{{ getPayStatus(order.payStatus) }}</span>
                        <button v-if="order.payId === constant.PAY_TYPE.CREDIT_CARD && ((order.isDeposit && canPaySurplus) || order.payStatus === constant.PAY_STATUS.NOT_PAY)" class="btn btn-highlight ms-2" @click="onPayClicked">{{ order.payStatus === constant.PAY_STATUS.NOT_PAY ? '重新付款' : '支付尾款' }}</button>
                      </div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">訂購時間</div>
                      <div class="col-8">{{ util.getDateTimeStr(order.addTime * 1000) }}</div>
                    </div>
                  </div>
                </div>
              </section>
              <section class="mb-5">
                <div>
                  <div class="title mb-3">收貨人資料</div>
                  <div class="container">
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">收貨人姓名</div>
                      <div class="col-8">{{ order.consignee }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">收貨人電話</div>
                      <div class="col-8">{{ order.mobile }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">收貨人地址</div>
                      <div class="col-8">{{ order.zipcode }} {{ getRegionName(order.city ) }}{{ getRegionName(order.district ) }} {{ order.address }}<template v-if="order.addressName">({{ order.addressName }})</template></div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">配送方式</div>
                      <div class="col-8">{{ order.shippingName }}</div>
                    </div>
                    <div class="row border-bottom border-dark pt-3 pb-3">
                      <div class="col-4">配送狀態</div>
                      <div class="col-8">{{ getShippingStatus(order.shippingStatus) }}</div>
                    </div>
                  </div>
                </div>
              </section>
              <section class="mb-5">
                <div class="title mb-3">訂單內容</div>
                <div class="container">
                  <div class="row pt-3 pb-3 align-items-center table-label border-bottom border-dark">
                    <div class="col-5 text-start">項目</div>
                    <div class="col-3 text-center gx-0">價格</div>
                    <div class="col-1 text-center gx-0">數量</div>
                    <div class="col-3 text-end">總計</div>
                  </div>
                  <div class="row pt-3 align-items-center border-bottom border-dark">
                    <template v-for="product in orderProducts">
                      <div class="col-5 text-start mb-3" :key="`goods-info-${product.recId}`">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0">
                            <div class="product-img" :style="util.getImageStyle(product.goodsImg)" @click="onClickProduct(product.goodsId)"></div>
                          </div>
                          <div class="flex-grow-1 ms-3">
                            <div class="product-name redirect-product-detail" @click="onClickProduct(product.goodsId)">{{ product.goodsName }}</div>
                            <div class="brand">{{ getBrandName(product.brandId) }}</div>
                            <!--div class="product-sn">{{ product.goodsSn }}</div-->
                            <div class="product-options" v-if="getOptionNames(product)">{{ getOptionNames(product) }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 text-center mb-3 gx-0" :key="`goods-price-${product.recId}`">
                        <small>{{ util.toPriceFormat(product.goodsPrice) }}</small>
                      </div>
                      <div class="col-1 text-center mb-3 gx-0" :key="`goods-amount-${product.recId}`">
                        <span>{{ product.goodsNumber }}</span>
                      </div>
                      <div class="col-3 text-end mb-3" :key="`goods-total-${product.recId}`">
                        <small>{{ util.toPriceFormat(product.goodsPrice * product.goodsNumber) }}</small>
                      </div>
                    </template>
                  </div>
                  <div class="row pt-3 pb-3 align-items-center border-bottom border-dark">
                    <div class="col text-start">
                      <small class="table-lead-col">總金額</small>
                    </div>
                    <div class="col text-end">
                      <small>{{ util.toPriceFormat(productTotalPrice) }}</small>
                    </div>
                  </div>
                  <div class="row pt-3 pb-3 align-items-center border-bottom border-dark" v-if="order.couponDiscount">
                    <div class="col text-start">
                      <small class="table-lead-col">優惠折扣</small>
                    </div>
                    <div class="col text-end">
                      <small>- {{ util.toPriceFormat(order.couponDiscount) }}</small>
                    </div>
                  </div>
                  <div class="row pt-3 pb-3 align-items-center border-bottom border-dark" v-if="order.discount > 0">
                    <div class="col text-start">
                      <small class="table-lead-col">會員折扣</small>
                    </div>
                    <div class="col text-end">
                      <small>- {{ util.toPriceFormat(order.discount) }}</small>
                    </div>
                  </div>
                  <div class="row pt-3 pb-3 align-items-center border-bottom border-dark">
                    <div class="col text-start">
                      <small class="table-lead-col">運費</small>
                    </div>
                    <div class="col text-end">
                      <small>{{ util.toPriceFormat(order.shippingFee) }}</small>
                    </div>
                  </div>
                  <!--
                  <div class="row pt-3 pb-3 align-items-center border-bottom border-dark">
                    <div class="col text-start">
                      <small class="table-lead-col">稅金(VAT 5.0%)</small>
                    </div>
                    <div class="col text-end">
                      <small>{{ util.toPriceFormat(order.tax) }}</small>
                    </div>
                  </div>
                  -->
                  <div class="row pt-3 pb-3 align-items-center mb-5">
                    <div class="col text-start">
                      <small class="table-lead-col">總計</small>
                    </div>
                    <div class="col text-end">
                      <small>{{ util.toPriceFormat(order.goodsAmount) }}</small>
                    </div>
                  </div>
                </div>
              </section>
              <section class="mb-5">
                <div class="title mb-3">訂單備註</div>
                <div class=""><small>{{ order.postscript }}</small></div>
                <div class=""><small>{{ order.bestTime }}</small></div>
              </section>
              <section class="d-none" v-if="creditInfo">
                <form id="credit-form" :action="creditInfo.redirectURL" method="post">
                  <input type="text" name="MerchantID" :value="creditInfo.merchantID">
                  <input type="text" name="TradeInfo" :value="creditInfo.tradeInfo">
                  <input type="text" name="TradeSha" :value="creditInfo.tradeSha">
                  <input type="text" name="Version" :value="creditInfo.version">
                  <input type="submit" value="submit">
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import orderApi from '@/api/order.js'
import productApi from '@/api/product.js'
import { mapGetters, mapMutations } from 'vuex'
import { unserialize } from 'php-serialize'

export default {
  name: 'OrderModal',
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      order: null,
      orderProducts: null,
      payments: null,
      creditInfo: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'getBrandName',
      'getRegionName'
    ]),
    constant: function () {
      return constant
    },
    util: function () {
      return util
    },
    productTotalPrice: function () {
      var ret = 0
      if (this.orderProducts) {
        this.orderProducts.forEach(e => {
          ret += (e.goodsNumber * e.goodsPrice)
        })
      }
      return ret
    },
    canPaySurplus: function () {
      return this.order && this.order.isDeposit && this.order.payStatus === constant.PAY_STATUS.DEPOSIT && this.order.shippingStatus === constant.SHIPPING_STATUS.DISTRIBUTING
    },
    atmPaymentInfo: function () {
      var ret = ''
      if (this.payments) {
        var atmPayment = this.payments.find(e => (e.payId === constant.PAY_TYPE.ATM))
        if (atmPayment) {
          ret = atmPayment.payDesc
        }
      }
      return ret
    }
  },
  watch: {
    id: function (value) {
      if (value) {
        this.apiGetOrder()
        this.apiGetOrderProducts()
      }
    }
  },
  mounted: function () {
    this.apiGetPayments()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetOrder: function () {
      var self = this
      orderApi.getOrder(this.id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.order = rspData
      })
    },
    apiGetOrderProducts: function () {
      var self = this
      orderApi.getOrderGoods(this.id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.orderProducts = rspData
        self.apiGetProductImages()
      })
    },
    apiGetProductImages: function () {
      if (!this.orderProducts) {
        return
      }
      var self = this
      this.orderProducts.forEach((e, i) => {
        productApi.getProduct(e.goodsId, function (err, rspData) {
          if (err) {
            if (err === constant.API_ERR_AUTH) {
              self.signOut()
            } else {
              alert(`${err}: ${rspData}`)
            }
            return
          }
          e.goodsImg = rspData.goodsImg
          e.brandId = rspData.brandId
          self.$set(self.orderProducts, i, e)
        })
      })
    },
    apiGetPayments: function () {
      var self = this
      orderApi.getPayments(function (err, rspData) {
        if (err) {
          alert(err)
          return
        }
        self.payments = rspData
      })
    },
    apiPayOrder: function () {
      var self = this
      orderApi.payOrder(this.id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        if (self.order.payId === constant.PAY_TYPE.CREDIT_CARD) {
          self.creditInfo = rspData
          self.$nextTick().then(() => {
            var form = document.getElementById('credit-form')
            if (form) {
              form.submit()
            }
          })
        }
      })
    },
    getOrderStatus: function (orderStatus) {
      var ret = ''
      switch (orderStatus) {
        case constant.ORDER_STATUS.NOT_CONFIRM:
          ret = '未確認'
          break
        case constant.ORDER_STATUS.CONFIRMED:
          ret = '已確認'
          break
        case constant.ORDER_STATUS.CANCELED:
          ret = '取消'
          break
        case constant.ORDER_STATUS.INVALID:
          ret = '無效'
          break
        case constant.ORDER_STATUS.RETURN:
          ret = '退貨'
          break
        default:
          break
      }
      return ret
    },
    getShippingStatus: function (status) {
      var ret = ''
      switch (status) {
        case constant.SHIPPING_STATUS.NOT_SHIP:
          ret = '未發貨'
          break
        case constant.SHIPPING_STATUS.SHIPPED:
          ret = '已發貨'
          break
        case constant.SHIPPING_STATUS.DELIVERED:
          ret = '收貨確認'
          break
        case constant.SHIPPING_STATUS.DISTRIBUTING:
          ret = '配貨中'
          break
        default:
          break
      }
      return ret
    },
    getPayStatus: function (status) {
      var ret = ''
      switch (status) {
        case constant.PAY_STATUS.NOT_PAY:
          ret = '未付款'
          break
        case constant.PAY_STATUS.PAYING:
          ret = '付款中'
          break
        case constant.PAY_STATUS.PAYED:
          ret = '已付款'
          break
        case constant.PAY_STATUS.DEPOSIT:
          ret = '已付訂金'
          break
        default:
          break
      }
      return ret
    },
    getOptionNames: function (orderProduct) {
      var ret = ''
      if (orderProduct && orderProduct.goodsAttr) {
        var attrs = unserialize(orderProduct.goodsAttr)
        if (attrs) {
          if (attrs instanceof Array) {
            attrs.forEach(attr => {
              for (const id in attr) {
                if (ret.length > 0) {
                  ret += '，'
                }
                ret += attr[id].value
              }
            })
          } else {
            for (const id in attrs) {
              if (ret.length > 0) {
                ret += '，'
              }
              ret += attrs[id].value
            }
          }
        }
      }
      return ret
    },
    onPayClicked: function () {
      this.apiPayOrder()
    },
    onClickProduct: function (id) {
      window.open(`/w/product/detail/${id}`)
    }
  }
}
</script>

<style scoped>
.order-id {
  font-size: 2rem;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
}
.title {
  font-size: 1.3rem;
  font-weight: 500;
}
.table-label {
  font-size: 1.1rem;
}
.table-lead-col {
  font-weight: 500;
}
.product-img {
  width: 64px;
  padding-bottom: 100%;
}
.brand {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.1rem;
}
.product-name {
  font-size: 1rem;
}
.product-sn, .product-options {
  font-size: 0.8rem;
}
.btn-highlight {
  color: var(--bs-white);
  background-color: var(--loft-color);
}
.redirect-product-detail {
  cursor: pointer;
}
</style>
